import * as React from 'react';

import * as styles from './dropdownMenu.module.scss';

interface DropdownMenuProps {
  children: React.ReactNode;
  isOpen: boolean;
  title: string;
  setIsOpen: (v: boolean) => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = props => {
  const dropdownMenu = React.useRef<HTMLDivElement>(null);

  const toggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    const shouldFocus = !props.isOpen;

    event.preventDefault();
    props.setIsOpen(!props.isOpen);

    if (shouldFocus && dropdownMenu.current) {
      const dropdownMenuLinks = dropdownMenu.current.getElementsByTagName('a');
      if (dropdownMenuLinks.length > 0) {
        dropdownMenuLinks[0].focus();
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <button
        role="button"
        aria-haspopup="true"
        aria-expanded={props.isOpen ? true : null}
        onClick={toggle}
        className={`${styles.button} ${props.isOpen ? styles.menuOpen : ''}`}>
        {props.title}
      </button>
      <div
        ref={dropdownMenu}
        className={`${styles.panel} ${props.isOpen ? styles.open : ''}`}>
        {props.children}
      </div>
    </div>
  );
};

export default DropdownMenu;
